import { combineReducers } from '@reduxjs/toolkit';

import EnferadiBimehNamehDetailSlice from '../../Detail/Actions/reducer';
import elhaghiyehHayeSaderehSlice from '../../ElhaghiyehHayeSadereh/Actions/reducer';
import enferadiEstelamSlice from '../../Estelam/Actions/reducer';

export const havadesEnferadiReducers = combineReducers({
  estelam: enferadiEstelamSlice,
  EnferadiBimehNamehDetail: EnferadiBimehNamehDetailSlice,
  elhaghiyehHayeSadereh: elhaghiyehHayeSaderehSlice,
});
